import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { useTranslation, Trans } from 'react-i18next';

import '../../App.css';
import Icon from '../Icons/Icon';
import { Input } from '../Input';
import colours from '../../Colours';

const ContactUs = (props) => {
    let APP_URL = window.location.hostname;

    if (APP_URL.includes('www.'))
        APP_URL = APP_URL.slice(4, undefined);

    const { t, i18n } = useTranslation();

    const [fullName, setFullName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [message, setMessage] = useState('');
    const [showConfirm, setShowConfirm] = useState(false);
    const [errors, setErrors] = useState({
        fullName: '',
        email: '', 
        phoneNumber: '',
        message: '',
    });

    const clearError = (name) => {
        if (name && errors[name]) {
          let newErrors = errors;
          newErrors[name] = '';
          setErrors(newErrors);
        }
      }

    const submitContact = () => {
        fetch("https://api." + APP_URL + "/api/v1/contact-us", {
            method: "POST",
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              "full_name": fullName,
              "phone_number": phoneNumber,
              "email": emailAddress,
              "message": message,
              "language": i18n.language,
              "domain": APP_URL
          })
        })
        .then(response => {
            return response.json();
        })
        .then(jsonResponse => {
          if (jsonResponse.errors) {
            let newErrors = {};
            jsonResponse.errors.map((err) => {
              newErrors[err.property + ''] = Object.values(err.constraints)[0];
              return null;
            });
            setErrors(newErrors);
          } else {
              setShowConfirm(true);
              let newErrors = {};
              setErrors(newErrors);
          }
        })
        .catch((error) => {
          // console.log('error');
          // console.log(error);
        });
    }

    const padding = 24; // adjust this to your needs
    let height = (460 + padding);
    let heightPx = height + 'px';
    let heightOffset = height / 2;
    let offsetPx = heightOffset + 'px';

    const style = {
      content: {
        border: '0',
        borderRadius: '4px',
        bottom: 'auto',
        height: heightPx,  // set height
        left: '50%',
        padding: '1rem',
        position: 'fixed',
        right: 'auto',
        top: '50%', // start from center
        transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
        width: '80%',
        maxWidth: '40rem'
      }
    };

    return (
        <ReactModal isOpen={props.isOpen} onRequestClose={props.closeModal} style={style} > {/*portalClassName="maxwidthmodal"*/}
            <div className="contact-modal-container" aria-modal="true" role="dialog">
                <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                    {showConfirm ? 
                        <>
                            <div style={{display: 'flex', flexDirection: 'row', flex: 1, maxHeight: 64}}>
                                <div className="modal-header-icon" style={{flex: 1, paddingTop: 32, marginLeft: 20, justifyContent: 'center'}}>
                                    <Icon name="SuccessForm" size={64} style={{color: colours.validate_green}}/>
                                </div>
                                <div className="modal-close-icon" onClick={props.closeModal}>
                                    <Icon name="Close" size={20} />
                                </div>
                            </div>
                            <div className="confirm-modal-header-text">
                                <Trans>Thank you!</Trans>
                            </div>
                            <div className="P3" style={{marginTop: 16, textAlign: 'center'}}>
                                <Trans>Your message has been submitted and we will contact you shortly about your request.</Trans>
                            </div>
                            <div style={{marginTop: 24, display: 'flex', flexDirection: 'row', flex: 1, paddingBottom: 16, justifyContent: 'center'}}>
                                <div className="contact-modal-cancel-button" style={{marginRight: 0}} onClick={props.closeModal}>
                                    <Trans>Close</Trans>
                                </div>
                            </div>
                        </>
                        : 
                        <>
                            <div style={{display: 'flex', flexDirection: 'row', flex: 1, maxHeight: 24}}>
                                <div className="modal-header-icon" style={{flex: 1, justifyContent: 'center'}}></div>
                                <div className="modal-close-icon" onClick={props.closeModal}>
                                    <Icon name="Close" size={20} />
                                </div>
                            </div>
                            <div className="H5">
                                <Trans>Contact Us</Trans>
                            </div>
                            <div className="P2" style={{marginTop: 16, textAlign: 'center'}}>
                                <Trans>If you have any questions regarding the Subaru Canada Adventure On Contest, connect with us here and we will get you back on track.</Trans>
                            </div>
                            <div className="contact-modal-form-container">
                                <div className="input-container modal-input">
                                    <Input 
                                        label={t("Full Name")} 
                                        required 
                                        value={fullName} 
                                        onChange={(val)=>{
                                            setFullName(val.target.value);
                                            clearError('fullName');
                                        }}
                                        variant={errors.fullName ? 'error' : ''}
                                        message={errors.fullName ? t(errors.fullName) : ''}
                                    />
                                </div>
                                <div className="input-container modal-input" style={{display: 'flex', flex: 2, flexDirection: 'row'}}>
                                    <div style={{display: 'flex', flexDirection: 'column', flex: 1, paddingRight: 24}}>
                                        <Input 
                                            label={t("Email Address")} 
                                            required 
                                            value={emailAddress}
                                            onChange={(val)=>{
                                                setEmailAddress(val.target.value);
                                                clearError('email');
                                            }}
                                            variant={errors.email ? 'error' : ''}
                                            message={errors.email ? t(errors.email) : ''}
                                        />
                                    </div>
                                    <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                                        <Input 
                                            label={t("Phone Number")}
                                            placeholder="(123) 123-1234"
                                            value={phoneNumber}
                                            onChange={(val)=>{
                                                setPhoneNumber(val.target.value);
                                                clearError('phoneNumber');
                                            }}
                                            variant={errors.phoneNumber ? 'error' : ''}
                                            message={errors.phoneNumber ? t(errors.phoneNumber) : ''}
                                        />
                                    </div>
                                </div>
                                <div className="input-container modal-input">
                                    <Input 
                                        label={t("Message")} 
                                        textarea 
                                        required 
                                        value={message} 
                                        onChange={(val)=>{
                                            setMessage(val.target.value);
                                            clearError('message');
                                        }}
                                        variant={errors.message ? 'error' : ''}
                                        message={errors.message ? t(errors.message) : ''}
                                    />
                                </div>
                                <div className="two-button-container">
                                    <div className="contact-modal-cancel-button" onClick={props.closeModal}>
                                        <Trans>Cancel</Trans>
                                    </div>
                                    <div className="contact-modal-submit-button" onClick={()=>{submitContact()}}>
                                        <Trans>Submit</Trans>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        </ReactModal>
    )
 }

 export default ContactUs;